import { ICreditDeleteDocumentsParams, ICreditDeleteDocumentsResponse, ICreditRepository } from "@/core/repositories/credit";

export class DeleteCreditDocumentsUseCase {
  constructor(private readonly creditRepository: ICreditRepository) {}

  async execute(params: ICreditDeleteDocumentsParams, currentPage: number): Promise<ICreditDeleteDocumentsResponse> {
    return this.creditRepository.deleteCreditDocuments(params, currentPage);
  }
}
